import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Analytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/wrapped.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/styles/util.module.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/Footer.module.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/Navigation.module.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/Layout.module.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/Research.module.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/Policy.module.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/Content.module.scss");
